import React from 'react';
import './../../../../../style/Vars.css';
import './../../../../../style/ContainersStyles.css';
import './../../../../../style/ElementsStyle.css';
import EstudiantesCatalog from './EstudiantesCatalog';

export default function EstudiantesPage() {
  return <EstudiantesCatalog />;
}
